import React from "react";
import { Activity } from "lucide-react";
import { cn } from "../../lib/utils";
import DateCell from "./DateCell";
import EmptyState from "./EmptyState";

const ActivityTimeline = ({
  items = [],
  className = "",
  emptyTitle = "لا توجد أنشطة حديثة",
}) => {
  if (!items.length)
    return (
      <EmptyState
        icon={Activity}
        title={emptyTitle}
        description="ستظهر هنا آخر العمليات والتنبيهات عند توفرها."
      />
    );
  return (
    <ol
      className={cn(
        "relative space-y-4 before:absolute before:right-4 before:top-2 before:h-[calc(100%-1rem)] before:w-px before:bg-neutral-200 dark:before:bg-neutral-800",
        className,
      )}
    >
      {items.map((item, index) => {
        const Icon = item.icon || Activity;
        return (
          <li key={item.id || index} className="relative flex gap-3 pr-10">
            <span
              className="absolute right-0 top-0 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white text-primary-700 ring-1 ring-neutral-200 dark:bg-neutral-900 dark:text-primary-300 dark:ring-neutral-800"
              aria-hidden="true"
            >
              <Icon size={15} />
            </span>
            <div className="min-w-0 flex-1 rounded-xl border border-neutral-200 bg-white p-3 dark:border-neutral-800 dark:bg-neutral-900">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <p className="font-semibold text-neutral-900 dark:text-neutral-100">
                  {item.title}
                </p>
                <DateCell
                  value={item.date || item.created_at || item.timestamp}
                />
              </div>
              {item.description && (
                <p className="mt-1 text-sm leading-6 text-neutral-500 dark:text-neutral-400">
                  {item.description}
                </p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
};

export default ActivityTimeline;
